import { render, staticRenderFns } from "./CentralizedIssueStatus.vue?vue&type=template&id=15cf5489&scoped=true"
import script from "./CentralizedIssueStatus.vue?vue&type=script&lang=js"
export * from "./CentralizedIssueStatus.vue?vue&type=script&lang=js"
import style0 from "./CentralizedIssueStatus.vue?vue&type=style&index=0&id=15cf5489&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15cf5489",
  null
  
)

export default component.exports